import { DesignersStoreState } from '~/domain/interfaces'

export default {
  total: (state: DesignersStoreState) => state.total,
  featured: (state: DesignersStoreState) => state.featured,
}
